import { useEffect, useState } from "react";
import axios from "axios";
import { SelectOption } from "../types";
import { adminService } from "../../../../../configs/constants";

export const useGeneralServiceRequest = () => {
  const [data, setData]: any = useState<SelectOption | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${adminService}/maintenance/category?serviceType=service`
      );
      setData(response.data?.result);
      setError(null);
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, loading, error, refetch: fetchData };
};
